import React from 'react';

const Loading = () => {
  return (
    <div className='loading'>
      <h4>Loading...</h4>
    </div>
  );
};

export default Loading;
